import MpTextField from "src/components/MpTextField";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import { FilterFieldsKeys } from "src/views/Ledger/LedgerBalanceMonitor/types/FilterFields";

function WalletAddressTextField({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t, tc } = useTranslation(translatePrefix);
  return (
    <MpTextField
      label={tc("phInputField", { fieldName: t(FilterFieldsKeys.ClientId) })}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export default WalletAddressTextField;
